import * as React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import {useLocation, useNavigate} from "react-router-dom";
import {useIntl} from "react-intl";
import {setSelectedParlayId} from "../../stores/pickX/pickX.slice";
import {useDispatch, useSelector} from "react-redux";

import './BottomNavigationBar.style.scss';
import GlobalConst from "../../constants/GlobalConst";
import {selectUserIsAuthenticated} from "../../stores/account/account.selectors";
const BottomNavigationBar = ({hide}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [value, setValue] = React.useState('Lobby');
    const intl = useIntl();
    const isUserAuthenticated = useSelector(selectUserIsAuthenticated);



    const handleChange = (event, newValue) => {
        setValue(newValue);
        navigate(`/${newValue}`);
    };
    const handleLobbyClick = () => {
        dispatch(setSelectedParlayId(null));
    }
    const handleMyPicksClick = ()=>{
        dispatch(setSelectedParlayId(null));
    }

    const handleRedirectMyAccountClick = () => {
        window.location.href = `${GlobalConst.SITE_URLS.TRADEFAN}/lobby?pickx=1`;
    }

    const isLandingPage = location.pathname === '/';
    if (isLandingPage)
        return null;

    return (
        <BottomNavigation className="BottomNavigationBar"
                          showLabels
                          value={value}
                          onChange={handleChange}>
            <BottomNavigationAction
                label="LOBBY"
                value="lobby"
                onClick={handleLobbyClick}
            />
            <BottomNavigationAction
                label={isUserAuthenticated ?
                    intl.formatMessage({ id: 'bottomNavigationBar.myPicks' })
                    :
                    intl.formatMessage({ id: 'bottomNavigationBar.faq' })}
                value={`${isUserAuthenticated ? "MyAccount/MyPicks/OnGoing": "faq"}`}
                onClick={handleMyPicksClick}
            />
            <BottomNavigationAction
                label={intl.formatMessage({ id: 'bottomNavigationBar.howToPlay' })}
                value="howToPlay"
            />
            <BottomNavigationAction
                label="LIVE FANTASY"
                value="liveFantasy"
                className="liveFantasy"
                onClick={handleRedirectMyAccountClick}
            />
        </BottomNavigation>
    );
}

export default BottomNavigationBar;